export enum OrderBy {
    DATE_DESC,
    DATE_ASC,
    USERNAME_ASC,
    USERNAME_DESC,
}
